import { Outlet, useOutletContext } from 'react-router-dom'

import TeamView from 'modules/calendar/components/TeamView'
import { useCalendarLeaves } from 'modules/calendar/hooks/useCalendarLeaves'
import type { RouteContextParams } from 'modules/calendar/lib/RouteContextParams'

const TeamViewPage = () => {
  const { date, filtersForm, loading, range, onDateRangeChange, canSeeCalendar, canSeeJobTitle } =
    useOutletContext<RouteContextParams>()
  const { lastLeaveUpdatedInMilliseconds } = useCalendarLeaves()

  return (
    <TeamView
      lastLeaveUpdatedInMilliseconds={lastLeaveUpdatedInMilliseconds}
      filtersForm={filtersForm}
      date={date}
      loading={loading}
      range={range}
      onDateRangeChange={onDateRangeChange}
      canSeeCalendar={canSeeCalendar}
      canSeeJobTitle={canSeeJobTitle}
    >
      <Outlet />
    </TeamView>
  )
}

export default TeamViewPage
